import App from '../../app';
const AMPLITUDE_EVENT_NAME = "Pageview: Maintenance";
export default function MaintenanceController($scope, gettextCatalog) {

  'ngInject';

  $scope.title = "Maintenance";

  this.$onInit = () => {
    App.amplitude.track(AMPLITUDE_EVENT_NAME);
  }

  $scope.menuItems = [{
    "title": gettextCatalog.getString("Board"),
    "sref": "maintenance.maintenanceboard"
  }, {
    "title": gettextCatalog.getString("Plans"),
    "sref": "maintenance.plans"
  }, {
    "title": gettextCatalog.getString("Plans"),
    "sref": "maintenance.plans"
  }, {
    "title": gettextCatalog.getString("Completed Tasks"),
    "sref": "maintenance.maintenanceCompletedtasks"
  }];
}